import { Icon } from '#/components/Icon/Icon';

import { DropdownChevronHolder } from './DropdownChevron.styled';

type Props = {
  size?: number;
  noMarginLeft?: boolean;
};

export function DropdownChevron({ size = 9, noMarginLeft }: Props) {
  return (
    <DropdownChevronHolder style={{ marginLeft: noMarginLeft ? 0 : undefined }}>
      <Icon name="chevron-down" size={size} />
    </DropdownChevronHolder>
  );
}
